@switch (severity) {
    @case (ServerityType.NUMBER_3) {
        <div>
            <span class="text-danger"><i class="fas fa-times-circle fa-lg"></i></span>
        </div>
    }
    @case (ServerityType.NUMBER_2) {
        <div>
            <span class="text-warning"><i class="fas fa-exclamation-circle fa-lg"></i></span>
        </div>
    }
    @case (ServerityType.NUMBER_1) {
        <div>
            <span class="text-primary"><i class="fas fa-question-circle fa-lg"></i></span>
        </div>
    }
    @case (ServerityType.NUMBER_0) {
        <div>
            <span class="text-info"><i class="fas fa-info-circle fa-lg"></i></span>
        </div>
    }
}
